/* eslint-disable import/prefer-default-export */
import fetch from 'isomorphic-fetch';
import * as ActionType from './types/SeatingChartActionTypes';
import { confirmation } from './NotificationActions';

function requestChart() {
  return {
    type: ActionType.REQUEST_CHART
  };
}

function receiveChart(json) {
  return {
    type: ActionType.RECEIVE_CHART,
    payload: {
      guest: json
    }
  };
}

function requestCharts() {
  return {
    type: ActionType.REQUEST_CHARTS
  };
}

function receiveCharts(json) {
  return {
    type: ActionType.RECEIVE_CHARTS,
    payload: json
  };
}

function deleteChart() {
  return {
    type: ActionType.DELETE_CHART
  };
}

function createChart() {
  return {
    type: ActionType.CREATE_CHART
  };
}

function updateChart() {
  return {
    type: ActionType.UPDATE_CHART
  };
}
/*
function changeView() {
  return {
    type: ActionType.CHANGE_VIEW
  };
}

function showDetails() {
  return {
    type: ActionType.SHOW_DETAILS
  };
}
*/
function requestTable() {
  return {
    type: ActionType.REQUEST_TABLE
  };
}

function receiveTable(json) {
  return {
    type: ActionType.RECEIVE_TABLE,
    payload: {
      guest: json
    }
  };
}

function requestTables() {
  return {
    type: ActionType.REQUEST_TABLES
  };
}

function receiveTables(json) {
  return {
    type: ActionType.RECEIVE_TABLES,
    payload: json
  };
}

function deleteTable() {
  return {
    type: ActionType.DELETE_TABLE
  };
}

function createTable() {
  return {
    type: ActionType.CREATE_TABLE
  };
}

function updateTable() {
  return {
    type: ActionType.UPDATE_TABLE
  };
}

export function getChart(chartId) {
  return (dispatch) => {
    dispatch(requestChart());
    return fetch(`/id/${chartId}`,
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveChart(json)));
  };
}

export function fetchChartList() {
  return (dispatch) => {
    dispatch(requestCharts());
    return fetch('/list/all',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
      })
      .then(response => response.json())
      .then(json => dispatch(receiveCharts(json)));
  };
}

export function deleteSeatingChart(chartId) {
  return dispatch => (
    fetch(`/id/${chartId}/delete`,
      {
        method: 'POST',
        credentials: 'same-origin'
      })
      .then(() => dispatch(deleteChart(chartId)))
      .then(() => dispatch(confirmation({ message: 'Seating Chart Deleted' })))
  );
}

export function addNewChart(chartRequest) {
  return (dispatch) => {
    dispatch(createChart());
    return fetch('/web-api/v1',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(chartRequest)
      })
      .then(response => response.json());
  };
}

export function editChart(chartRequest) {
  return (dispatch) => {
    dispatch(updateChart());
    return fetch('/web-api/v1/',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(chartRequest)
      })
      .then(response => response.json());
  };
}

export function getTable(tableId) {
  return (dispatch) => {
    dispatch(requestTable());
    return fetch(`/id/${tableId}`,
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveTable(json)));
  };
}

export function fetchAllTable() {
  return (dispatch) => {
    dispatch(requestTables());
    return fetch('/list/all',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
      })
      .then(response => response.json())
      .then(json => dispatch(receiveTables(json)));
  };
}

export function removeTable(tableId) {
  return dispatch => (
    fetch(`/id/${tableId}/delete`,
      {
        method: 'POST',
        credentials: 'same-origin'
      })
      .then(() => dispatch(deleteTable(tableId)))
      .then(() => dispatch(confirmation({ message: 'Table Deleted' })))
  );
}

export function addNewTable(tableRequest) {
  console.log(tableRequest);
  return (dispatch) => {
    dispatch(createTable());
    return fetch('/web-api/v1',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(tableRequest)
      })
      .then(response => response.json());
  };
}

export function editTable(tableRequest) {
  return (dispatch) => {
    dispatch(updateTable());
    return fetch('/web-api/v1/',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(tableRequest)
      })
      .then(response => response.json());
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/SeatingChartActions.js
 **/